import {handleAPI, API_VERSION_ONE} from '../../../itrust_common/utils/apiUtils';
const parent = 'SETTING_'
export function patientTemplateLoad(filters){
  const url = `/anonymous/${API_VERSION_ONE}/patient_templates`;
  const method = 'GET'

  return {
    type: `${parent}PATIENT_TEMPLATE_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}
